import { fromJS } from 'immutable';

export const FILL = 'kroost/stats/FILL';
export const ADD_SPREAD_STATE = 'kroost/stats/ADD_SPREAD_STATE';

// Initial routing state
const initialState = fromJS({
  spreads: {},
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_SPREAD_STATE:
      return state.setIn([action.orderId, 'spreads', action.spreadId, action.name], action.value);
    case FILL:
      return state.set(action.orderId, fromJS(action.stats));
    default:
      return state;
  }
}

export function addSpreadStat(orderId, spreadId, name, value) {
  return {
    type: ADD_SPREAD_STATE,
    orderId,
    spreadId,
    name,
    value,
  };
}

export function fill(orderId, stats) {
  return {
    type: FILL,
    orderId,
    stats,
  };
}



// WEBPACK FOOTER //
// ./app/redux/reducers/stats.js